import React from "react";
import NumberInput from "./NumberInput";

interface Props {
  currency: server.dto.Currencies
  value: number
  onChange: (value: number) => void
  canBeEmpty: boolean
  canBeNegative: boolean
  maxValue?: number
}

const CurrencyInput = (props: Props) => {
  return <div> <NumberInput
    value={props.value}
    onChanged={v => { props.onChange(v.value); }}
    decimalPoints={2}
    canBeEmpty={props.canBeEmpty}
    canBeNegative={props.canBeNegative}
    labelContent={props.currency.toUpperCase()}
    maxValue={props.maxValue ?? 10000000000}
    width={90}
  /></div>;
};

export default CurrencyInput;